import {observer} from "mobx-react-lite";
import {useSearchParams} from "react-router-dom";
import {categoryStore} from "../../../../Stores/CategoryStore";
import {MobileContainer} from "../../../Global/Global";
import Space from "../../../Common/Space";
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Tabs, Typography, useTheme} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import Row from "../../../Common/Row";

export const CategoryFilterSkeleton = () => {
    // Generate loading rows
    let boxes = [];
    const widths = ["20%", "25%", "20%", "20%", "15%"]
    for (let i = 0; i < widths.length; i++) {
        boxes.push(
            <Skeleton
                key={"category-filter-mobile-skeleton-" + i}
                variant="rectangular"
                sx={{
                    boxSizing: "border-box",
                    borderRadius: "5px",
                    minWidth: `calc(${widths[i]} - 5px)`,
                    margin: "0 5px 10px 0",
                }}
            >
                <Typography sx={{
                    padding: "10px 0",
                }}>
                    null
                </Typography>
            </Skeleton>
        )
    }

    return <MobileContainer>
        {/* Title */}
        <Skeleton
            variant="rectangular"
            sx={{borderRadius: "4px"}}
        >
            <Typography variant="h4">Alle kategorier</Typography>
        </Skeleton>

        <Space height="10px" />

        {/* Category boxes */}
        <Row sx={{justifyContent: "start"}}>
            {boxes}
        </Row>
    </MobileContainer>
}

const CategoryTabItem = ({name, path, resetFilters}) => {
    const theme = useTheme();
    const [ searchParams, setSearchParams ] = useSearchParams();

    return <React.Fragment>
        <Typography
            sx={{
                padding: "10px 15px",
                cursor: "pointer",
                backgroundColor: theme.palette.grey[200],
                borderRadius: "5px",
                fontSize: "18px"
            }}
            onClick={() => {
                // Clear all parameters except 'category', 'price', 'radius', and 'latLng'
                Array.from(searchParams.keys()).forEach(key => {
                    if (key !== 'category' && key !== 'price' && key !== 'radius' && key !== 'latLng') {
                        searchParams.delete(key);
                    }
                });

                searchParams.set("category", path);
                setSearchParams(searchParams);
            }}
        >{name}</Typography>
        <Space width="5px"/>
    </React.Fragment>
}

export const CategoryFilterMobile = observer(({categories}) => {
    const [ searchParams, setSearchParams ] = useSearchParams();

    if (!categoryStore.isInitialized)
        return <CategoryFilterSkeleton/>;

    const param = searchParams.get("category")?.split(" > ");
    const prefix = param?.slice(0, param.length - 1).join(" > ");

    let level = categoryStore.categoryTree;
    let levelHasChildren = true;
    for (let index = 0; index < param?.length; index++) {
        const nextLevel = level?.find(c => c.name == param[index]).children;

        if (nextLevel.length == 0) {
            levelHasChildren = false;
            break;
        }

        level = nextLevel;
    }

    const levelLabels = level.map(category => category.name);

    const showBackArrow = param?.length > 0;
    const title = param?.[param.length -1] ?? "Alle kategorier";

    const goBack = () => {
        // Clear all parameters except 'category', 'price', 'radius', and 'latLng'
        Array.from(searchParams.keys()).forEach(key => {
            if (key !== 'category' && key !== 'price' && key !== 'radius' && key !== 'latLng') {
                searchParams.delete(key);
            }
        });

        if (param.length == 1) {
            searchParams.delete("category")
        } else {
            searchParams.set("category", prefix);
        }

        setSearchParams(searchParams);
    }

    return <MobileContainer>
        <Space height="10px" />
        {showBackArrow && (
            <React.Fragment>
                <ArrowBackIcon
                    sx={{cursor: "pointer"}}
                    onClick={goBack}
                />
                <Space height="5px" />
            </React.Fragment>
        )}
        <Typography variant="h4">{title}</Typography>
        <Space height="10px" />
        <Tabs
            value={false}
            variant="scrollable"
            scrollButtons={false}
        >
            {levelLabels.map(item => {
                let path = item;

                if (param?.length > 0) {
                    if (levelHasChildren) {
                        path = [...param, item].join(" > ");
                    } else if (prefix) {
                        path = `${prefix} > ${item}`;
                    }
                }

                return <CategoryTabItem
                    key={"category-filter-mobile-" + path}
                    name={item}
                    path={path}
                />
            })}
        </Tabs>
        <Space height="10px" />
    </MobileContainer>
})